import { render, staticRenderFns } from "./EBotaoAtendimentoIA.vue?vue&type=template&id=22d5f786"
import script from "./EBotaoAtendimentoIA.vue?vue&type=script&lang=js"
export * from "./EBotaoAtendimentoIA.vue?vue&type=script&lang=js"
import style0 from "./EBotaoAtendimentoIA.vue?vue&type=style&index=0&id=22d5f786&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports